import React, { useState, useEffect } from "react";
import Axios from "axios";

import backendURL from "./backendURL";
import { Waypoint } from "react-waypoint";

// Css
import "./Feed.css";

import trincotParse from "./scripts/trincotParse";

import Zoom from "@material-ui/core/Zoom";
import Fade from "@material-ui/core/Fade";
import FeedSkeleton from "./FeedSkeleton";
import CodeIcon from "@material-ui/icons/Code";
import SubjectIcon from "@material-ui/icons/Subject";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

function Feed() {
  const [allFeed, setAllFeed] = useState([]);
  const [pageData, setPageData] = useState({
    page: 1,
    limit: 5,
  });
  const [hasMore, setHasMore] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [deadend, setDeadend] = useState(false);
  const [saveContent, setSaveContent] = useState({});

  const { page, limit } = pageData;
  useEffect(() => {
    const fetchAllFeed = async () => {
      const getFeed = await Axios.get(
        backendURL + `/feed?page=${page}&limit=${limit}`,
        null
      );
      const { feed, next } = getFeed.data;
      setAllFeed(feed);
      if (next) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }
    };
    fetchAllFeed();
  }, []);

  const loadMoreFeed = async () => {
    if (hasMore) {
      setShowLoader(true);
      const { page } = pageData;
      const nextPage = Number(page + 1);
      setPageData((prevState) => ({
        ...prevState,
        page: nextPage,
      }));
      const getFeed = await Axios.get(
        backendURL + `/feed?page=${nextPage}&limit=${pageData.limit}`,
        null
      );
      const { feed, next } = getFeed.data;
      setAllFeed((prevFeed) => [...prevFeed, ...feed]);
      if (next) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }
      setShowLoader(false);
    } else {
      setDeadend(true);
    }
  };

  const pendingFeed = (
    <>
      <Fade in={true} styles={{ transitionDuration: "1s" }}>
        <div>
          {Array.from({ length: 10 }, (_, index) => (
            <FeedSkeleton key={index} />
          ))}
        </div>
      </Fade>
    </>
  );

  const getCode = (element_id) => {
    const element = document.querySelector(`#content-${element_id}`);
    const element_type = element.getAttribute("view");
    const element_feed = element.querySelector(".feed__content");
    const element_codeIcon = element.querySelector(".icon__code");
    const element_content = element_feed.innerHTML;
    if (element_type == "normal") {
      element.style.transition = "background-color 0.5s ease-in-out !important";
      element.classList.add("feed__code_view");
      element.classList.add("quick-trans");
      setSaveContent((prev) => ({ ...prev, [element_id]: element_content }));
      const parsed = trincotParse(element_content, false);
      element_feed.innerHTML = parsed;
      element.setAttribute("view", "code");
    } else if (element_type == "code") {
      element_feed.innerHTML = saveContent[element_id];
      element.classList.remove("feed__code_view");
      element.setAttribute("view", "normal");

      setSaveContent((prev) => delete prev[element_id]);
    }
  };

  const loaderDiv = (
    <Waypoint onEnter={loadMoreFeed}>
      {allFeed.length > 0 ? (
        <div className="feed__loader">
          {showLoader ? <CircularProgress color="black" /> : null}
          {deadend ? <h5>No more content.</h5> : null}
        </div>
      ) : null}
    </Waypoint>
  );
  return (
    <div
      className="feed"
      style={{ overflowY: allFeed.length == 0 ? "hidden" : "auto" }}
    >
      {allFeed.length == 0 ? pendingFeed : null}
      {allFeed.map((feed, i) => (
        <>
          <Zoom
            in={true}
            style={{
              transitionDuration: "0.8s",
              transitionDelay: `${(i % limit) * 0.3}s`,
            }}
          >
            <div
              className="feed__box"
              key={feed._id}
              id={`content-${feed._id}`}
              view="normal"
            >
              <div className="feed__name">{feed.name}</div>
              <div className="feed__date">
                {timeAgo.format(new Date(feed.date), "twitter")}
              </div>
              {/* <Divider className="divider" style={{ background: "light" }} /> */}
              <div
                className="feed__content"
                dangerouslySetInnerHTML={{ __html: feed.content }}
              ></div>
              <div className="feed__code__btn">
                <IconButton
                  onClick={() => {
                    getCode(feed._id);
                  }}
                >
                  {!saveContent[feed._id] ? (
                    <CodeIcon style={{ color: "black" }} />
                  ) : (
                    <SubjectIcon style={{ color: "white" }} />
                  )}
                </IconButton>
              </div>
            </div>
          </Zoom>
        </>
      ))}
      {allFeed.length > 0 ? loaderDiv : null}
    </div>
  );
}

export default Feed;
